import global from '../config/global'
import storeActions from '../store/actions/index'
import secretServices from '../services/secret'
import environmentServices from '../services/environment'
import coreServices from '../services/core'

import { CipherType } from '../core-js/src/enums'

import { sortSecrets, sortEnvironments } from './common'

export { sortSecrets, sortEnvironments }

export async function socketSyncSecrets(messageData = { type: '', data: { project_id, id } }) {
  const { project_id, id } = messageData.data;
  let projectSecrets = global.store.getState().project.projectSecrets || [];
  if (messageData.type === 'secret_delete') {
    projectSecrets = projectSecrets.filter((s) => s.id != id);
  } else {
    const result = await secretServices.get(project_id, id);
    const secrets = await coreServices.decrypt_ciphers([result], CipherType.Secret);
    const secretItem = {
      id: result.id,
      key: secrets[0]?.secret?.key,
      name: secrets[0]?.secret?.key,
      hash: result.secret_hash,
      environmentId: result.environment_id,
      creationDate: secrets[0]?.creationDate,
      updatedDate: secrets[0]?.updatedDate,
      revisionDate: secrets[0]?.revisionDate,
      expiredDate: secrets[0]?.expiredDate,
    };
    const projectSecret = projectSecrets.find((s) => s.id == secrets[0]?.id);
    if (projectSecret) {
      projectSecrets = projectSecrets.map((s) => s.id == secrets[0]?.id ? {
        ...s,
        ...secretItem,
      } : s);
    } else {
      projectSecrets = [
        ...projectSecrets,
        secretItem,
      ];
    }
  }
  projectSecrets = sortSecrets(projectSecrets);
  global.store.dispatch(storeActions.updateProjectSecrets(projectSecrets));
}

export async function socketSyncEnvironments(messageData = { type: '', data: { project_id, id } }) {
  const { project_id, id } = messageData.data;
  let projectEnvironments = global.store.getState().project.projectEnvironments || [];
  if (messageData.type === 'env_delete') {
    projectEnvironments = projectEnvironments.filter((s) => s.id != id);
  } else {
    const result = await environmentServices.get(project_id, id);
    const envs = await coreServices.decrypt_ciphers([result], CipherType.Environment);
    const envItem = {
      id: result.id,
      name: envs[0]?.environment?.name,
      hash: result.hash,
      creationDate: envs[0]?.creationDate,
      updatedDate: envs[0]?.updatedDate,
      revisionDate: envs[0]?.revisionDate,
    };
    const projectEnv = projectEnvironments.find((s) => s.id == envs[0]?.id);
    if (projectEnv) {
      projectEnvironments = projectEnvironments.map((s) => s.id == envs[0]?.id ? {
        ...s,
        ...envItem,
      } : s);
    } else {
      projectEnvironments = [
        ...projectEnvironments,
        envItem,
      ];
    }
  }
  projectEnvironments = sortEnvironments(projectEnvironments);
  global.store.dispatch(storeActions.updateProjectEnvironments(projectEnvironments));
}